import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import { ResumenFirmasSqp } from '../../models/resumen-firmas-sqp';
import { ResumenEstados } from 'src/app/pages/panelControl/models/resumen-inicial';
import { ModificarArraysService } from 'src/app/shared/services/modificar-arrays.service';


@Component({
  selector: 'app-resumen-estados-sqp',
  templateUrl: './resumen-estados-sqp.component.html',
  styleUrls: ['./resumen-estados-sqp.component.css']
})
export class ResumenEstadosSqpComponent implements OnInit {

  @Input() resumenFirmas: ResumenFirmasSqp[] = [];
  @Input() resumenEstados: ResumenEstados[] = [];
  @Input() verNuevos: boolean = false;
  @Output() clickEstado: EventEmitter<string> = new EventEmitter<string>();
  @Input() estadoSeleccionado:string;
  @Input() verTooltip: boolean = false;
  @Input() colorSeleccion: string;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['resumenEstados']?.currentValue && this.verNuevos){
      this.resumenEstados.shift(); //quitamos el item todos en la home
    }
  }

  ngOnInit(): void {
  }

  clickTipoFirma(estado: string){
    this.clickEstado.emit(estado);
  }

  modificarTitulo(estado:string):string{
    // Check if there's a capital letter in the middle of the word
    const hasCapitalInMiddle = /[A-Z]/.test(estado.slice(1));

    if (hasCapitalInMiddle) {
      // Split by capital letters and join with spaces
      return estado.replace(/([A-Z])/g, ' $1')
                   .split(' ')
                   .map((word, index) => {
                     if (index === 0) {
                       return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                     } else {
                       return word.toLowerCase();
                     }
                   })
                   .join(' ')
                   .trim();
    } else {
      // Just capitalize the first letter
      return estado.charAt(0).toUpperCase() + estado.slice(1);
    }
  }

  capitalizeSingular(estado:string):string{
    let resultado;

    switch(estado.toUpperCase()){
      case 'BORRADORES':
        resultado = 'BORRADOR';
        break;
      case 'FIRMADOS':
        resultado = 'FIRMADO';
        break;
      case 'PARCIALMENTEFIRMADOS':
        resultado = 'PARCIALMENTE FIRMADO';
        break;
      case 'RECHAZADOS':
        resultado = 'RECHAZADO';
        break;
      case 'NOFIRMADOS':
        resultado = 'NO FIRMADO';
        break;
      case 'CADUCADOS':
        resultado = 'CADUCADO';
        break;
      case 'ERRORES':
        resultado = 'ERROR';
        break;
      case 'CANCELADOS':
        resultado = 'CANCELADO';
        break;
      case 'TODOS':
        resultado = 'TODOS';
        break;
    }
    return resultado
  }

}
